<p class="symbols">{{ symbolsCount() }}/{{ maxSymbols }}</p>
